import { Box, Typography } from "@mui/material";
import { semanticColors } from "../../../utils/colors";
import { typography } from "../../../utils/typography";

/**
 * A read-only "label: value" pair.
 *
 * Follows the same rule as the form fields: the label is a prompt and reads
 * grey, the value reads dark.
 */
export default function LabelledValue({
  label,
  value
}: {
  label: string;
  value?: string;
}) {
  return (
    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
      <Typography
        sx={{ ...typography.body.l, color: semanticColors.text.secondary }}
      >
        {label}
      </Typography>
      <Typography
        sx={{ ...typography.body.lBold, color: semanticColors.text.primary }}
      >
        {value}
      </Typography>
    </Box>
  );
}
